module.exports = __webpack_public_path__ + "static/media/Camera Dot_Br.410bcde2.svg";